import { Command, LayoutDashboard, CheckCircle, Target, Palette, FileText, Settings, Building2, Users, Hammer, Briefcase, Wrench, ListTodo, Kanban, Workflow } from 'lucide-react';

export const navigation = [
  {
    id: 'command',
    label: 'Command',
    icon: Command,
    areas: [
      { id: 'overview', label: 'Overview', icon: LayoutDashboard },
      { id: 'tasks', label: 'Tasks', icon: CheckCircle }
    ]
  },
  {
    id: 'sales',
    label: 'Sales Floor',
    icon: Users,
    areas: [
      { id: 'overview', label: 'Overview', icon: LayoutDashboard },
      { id: 'customers', label: 'Customers', icon: Users },
      { id: 'deals', label: 'Deals', icon: Briefcase },
      { id: 'tasks', label: 'Tasks', icon: CheckCircle }
    ]
  },
  {
    id: 'workshop',
    label: 'Workshop',
    icon: Wrench,
    areas: [
      { id: 'overview', label: 'Overview', icon: LayoutDashboard },
      { id: 'projects', label: 'Projects', icon: Briefcase },
      { id: 'tasks', label: 'Tasks', icon: ListTodo },
      { id: 'kanban', label: 'Kanban', icon: Kanban }
    ]
  },
  {
    id: 'development',
    label: 'Development',
    icon: Target,
    areas: [
      { id: 'vision', label: 'Vision & Goals', icon: Target },
      { id: 'brand', label: 'Brand Identity', icon: Palette },
      { id: 'docs', label: 'Documentation', icon: FileText }
    ]
  },
  {
    id: 'operations',
    label: 'Operations',
    icon: Settings,
    areas: [
      { id: 'overview', label: 'Overview', icon: LayoutDashboard },
      { id: 'company', label: 'Company', icon: Building2 },
      { id: 'contacts', label: 'Contacts', icon: Users },
      { id: 'tasks', label: 'Tasks', icon: CheckCircle },
      { id: 'settings', label: 'Settings', icon: Settings }
    ]
  }
];